import { useEffect } from 'react';
import useMyAppStore from '../stores/myAppStore';

export const useTheme = () => {
  const { theme } = useMyAppStore();

  useEffect(() => {
    // Remove both classes first
    document.documentElement.classList.remove('light', 'dark');
    // Add the current theme class
    document.documentElement.classList.add(theme);
  }, [theme]);

  return theme;
}; 